import { render, staticRenderFns } from "./ChartEdit22.vue?vue&type=template&id=22a7d662&scoped=true&"
import script from "./ChartEdit22.vue?vue&type=script&lang=js&"
export * from "./ChartEdit22.vue?vue&type=script&lang=js&"
import style0 from "./ChartEdit22.vue?vue&type=style&index=0&id=22a7d662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7d662",
  null
  
)

export default component.exports